<template>
  <div>
    <nav-title />
    <div class="layout-main">
      <div class="filter">
        <el-input size="small" v-model="name" placeholder="请输入用户名" class="cl-middle-font-size"/>
        <el-button type="primary" size="small" @click="openDialog('create')" v-if="hasAuth('131')">
          添加用户
        </el-button>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column prop="name" width="173" label="用户名">
        </el-table-column>
        <el-table-column prop="account" width="164" label="OA账户">
        </el-table-column>
        <el-table-column prop="email" label="邮箱"> </el-table-column>
        <el-table-column prop="role" width="141" label="角色名">
          <template slot-scope="scope">
            {{ scope.row.type === 301 ? '管理员' : '普通账户' }}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间"> </el-table-column>
        <el-table-column
          prop="id"
          label="操作"
          width="88"
          header-align="center"
          v-if="hasAuth('131')"
        >
          <template slot-scope="scope">
            <span class="action" @click="openDialog(scope.row.id)">
              <svg class="svg-icon edit" aria-hidden="true" v-popover:popover>
                <use :xlink:href="'#icon-edit'"></use>
              </svg>
            </span>
            <span class="action" @click="handleDelete(scope.row.id)">
              <svg class="svg-icon delete" aria-hidden="true" v-popover:popover>
                <use :xlink:href="'#icon-delete'"></use>
              </svg>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="user-list-dialog">
        <el-dialog
          title="编辑用户"
          :visible.sync="dialogVisible"
          width="600px"
          style="padding:0"
        >
          <edit-user v-on:close="closeDialog" ref="editUser" />
        </el-dialog>
      </div>
      <div class="pagination">
        <el-pagination
          class="cl-pagination"
          background
          layout="prev, pager, next , sizes"
          @size-change="handleSizeChange"
          @current-change="handleChangePage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          :current-page.sync="$store.state[namespace].page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import warning from 'assets/images/warning.png';
import EditUser from './EditUser';
import NavTitle from 'components/NavTitle';
import ListMixins from 'mixins/list';
import { hasAuth } from 'utils/auth';

export default {
  name: 'UsersList',
  mixins: [ListMixins],
  components: {
    'edit-user': EditUser,
    'nav-title': NavTitle
  },
  data() {
    return {
      name: '',
      namespace: 'account',
      dialogVisible: false,
      form: {}
    };
  },
  watch: {
    name() {
      this.queryList();
    }
  },
  beforeDestroy() {
    this.$store.commit('account/update', {
      condition: {},
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    });
  },
  methods: {
    hasAuth(val) {
      return hasAuth(val);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.refreshData();
    },
    openDialog(id) {
      setTimeout(() => {
        this.$refs.editUser.initForm(id);
      }, 0);
      this.dialogVisible = true;
    },
    queryList() {
      this.$store.commit('account/update', {
        condition: {
          name: this.name || undefined
        }
      });
      this.refreshData();
    },
    resetCondition() {
      this.$store.commit('account/update', {
        condition: {}
      });
      this.refreshData();
    },
    refreshData() {
      this.handleChangePage(1);
    },
    handleDelete(id) {
      this.$confirm(
        `
					<img src=${warning} alt="" width="59" st/>
					<p style="
						font-size: 16px;
						font-weight: bold;
						padding-bottom: 19px;
						display: block;
						color: rgba(0, 0, 0, 0.65);">
						确定删除该用户吗？
					</p>
				`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.$store
          .dispatch('account/delete', {
            id
          })
          .then(() => {
            this.refreshData();
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.action {
  color: #3fb7ff;
  cursor: pointer;
  padding: 0 10px;
}

.filter {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  > * {
    margin-right: 8px;
    max-width: 150px;
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 30px 0 0 0;
}

.cl-pagination {
  padding-bottom: 0;
}

.user-list-dialog {
  :global(.el-dialog) {
    border-radius: 4px;
    overflow: hidden;
    :global(.el-dialog__header) {
      background-color: #f4f6f8;
      > span {
        font-size: 16px;
        font-weight: bold;
        letter-spacing: -0.44px;
        color: rgba(0, 0, 0, 0.65);
      }
      > button {
        top: calc(50% - 10px);
      }
    }

    :global(.el-dialog__body) {
      padding: 0 !important;
    }
  }
}
</style>
